// @flow
import * as React from 'react';
import { isChrome } from 'utils/browser';
import { updateObject } from 'utils/functional';
import Input from 'components/Input';
import DelimitedInput from 'components/DelimitedInput';
import Field from './Field';

const InputField = ({
  name,
  label,
  description,
  matchGeneralError,
  type = 'text',
  mapError,
  autoComplete,
  inlineLabel,
  noMargin,
  noWrap,
  delimit,
  ...props
}: {
  name: string,
  label?: string,
  description?: string,
  matchGeneralError?: string,
  type?: string,
  mapError?: string => React.Node,
  autoComplete?: string,
  inlineLabel?: boolean,
  onUpdateValue?: string => void,
  noMargin?: boolean,
  noWrap?: boolean,
  delimit?: boolean
}) => {
  const autoCompleteString =
    autoComplete === 'off' && isChrome() ? 'foobar' : autoComplete;
  const inputProps = autoComplete
    ? updateObject(props, { autoComplete: autoCompleteString })
    : props;
  const InputComponent = delimit ? DelimitedInput : Input;
  return (
    <Field
      inputProps={inputProps}
      name={name}
      noMargin={noMargin}
      noWrap={noWrap}
      label={label}
      inlineLabel={inlineLabel}
      description={description}
      mapError={mapError}
      matchGeneralError={matchGeneralError}
      renderInput={({
        value,
        id,
        qaId,
        hasError,
        updateValue,
        onBlur,
        onFocus
      }) => (
        <InputComponent
          id={id}
          name={name}
          type={type}
          value={value || ''}
          hasError={hasError}
          data-qa-id={qaId}
          onChange={e => {
            const v = e.target.value;
            updateValue(v);
            if (props.onUpdateValue) {
              props.onUpdateValue(v);
            }
          }}
          onBlur={onBlur}
          onFocus={onFocus}
          {...inputProps}
        />
      )}
    />
  );
};

export default InputField;
